var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.3171 31.3842L5.57045 17.5386C4.26025 16.3085 2.29284 16.3085 0.982648 17.5386C-0.327549 18.7687 -0.327549 20.6159 0.982648 21.8461L20.318 40L57.3507 5.23009C58.6612 3.99994 58.6612 2.15274 57.3507 0.922606C56.0405 -0.307535 54.0731 -0.307535 52.7629 0.922606L20.3171 31.3842Z","fill":"black"}));
}

Check.defaultProps = {"width":"59","height":"40","viewBox":"0 0 59 40","fill":"none"};

module.exports = Check;

Check.default = Check;
